import { useCallback, useState } from "react";
import classNames from "classnames";
import { downloadDocument, getDocSizeString, getImgThumb, getItemIcon } from "../utils/documents";
import phImage from "../images/placeholder-image.png";
import Icon from "./icon";

const Document = ({ doc, removable = false, onRemove, disabled = false }) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const download = useCallback(async () => {
    setIsDownloading(true);
    await downloadDocument(doc);
    setIsDownloading(false);
  }, [doc]);

  return (
    <div
      className={classNames(
        "document",
        doc.type === "IMAGE" && "document--image",
        disabled && "disabled"
      )}
    >
      <div className="document__thumb">
        {doc.type === "IMAGE" ? (
          <img src={getImgThumb(doc) || phImage} alt={doc.clearFilename} />
        ) : (
          <Icon name={getItemIcon(doc.fileName)} />
        )}
      </div>
      <div className="document__main">
        <h3 className="document__name">{doc.clearFilename}</h3>
        <button className="document__download" type="button" onClick={download}>
          <div>{doc.extension.toUpperCase()}</div>
          <div>({getDocSizeString(doc.size)})</div>
          {isDownloading ? <span className="loading-spinner" /> : <Icon name="download" />}
        </button>
      </div>
      {removable && onRemove && (
        <button className="document__remove" type="button" onClick={onRemove} aria-label="Remove">
          <Icon name="cross" />
        </button>
      )}
    </div>
  );
};

export default Document;
